// components/FlashMessage.js
import { useEffect } from 'react';

export default function FlashMessage({ message, type = 'success', onClose }) {
  useEffect(() => {
    if (message) {
      const timer = setTimeout(onClose, 4000);
      return () => clearTimeout(timer);
    }
  }, [message, onClose]);

  if (!message) return null;

  return (
    <div className={`fixed bottom-5 left-4/12 transform z-50 px-6 py-3 rounded shadow-lg text-white ${
      type === 'success' ? 'bg-green-500' : 'bg-red-500'
    }`}>
      {message}
    </div>
  );
}
